module.exports = __webpack_public_path__ + "static/media/credit-card.2f1742d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/credit-card.svg
// module id = 836
// module chunks = 21